import { render } from "./UserRole.vue?vue&type=template&id=1707a606&ts=true"
import script from "./UserRole.vue?vue&type=script&lang=ts"
export * from "./UserRole.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__